import http from '../../../../api/http';
import type { BalanceGeneral, EstadoResultados, BalanceComprobacionLinea } from '../types/reportes';

const ENDPOINTS = {
  BASE: '/contabilidad/reportes',
};

export class ReporteContableService {
  public static async getBalanceGeneral(
    idEjercicio: number,
    periodoHasta: number,
    moneda: string = 'MN'
  ): Promise<BalanceGeneral> {
    const response = await http.get(
      `${ENDPOINTS.BASE}/balance-general?idEjercicio=${idEjercicio}&periodoHasta=${periodoHasta}&moneda=${moneda}`
    );
    return response.data;
  }

  public static async getEstadoResultados(
    idEjercicio: number,
    periodoDesde: number,
    periodoHasta: number,
    moneda: string = 'MN'
  ): Promise<EstadoResultados> {
    const response = await http.get(
      `${ENDPOINTS.BASE}/estado-resultados?idEjercicio=${idEjercicio}&periodoDesde=${periodoDesde}&periodoHasta=${periodoHasta}&moneda=${moneda}`
    );
    return response.data;
  }

  public static async getBalanceComprobacion(
    idEjercicio: number,
    periodoDesde: number,
    periodoHasta: number
  ): Promise<BalanceComprobacionLinea[]> {
    const response = await http.get(
      `${ENDPOINTS.BASE}/balance-comprobacion?idEjercicio=${idEjercicio}&periodoDesde=${periodoDesde}&periodoHasta=${periodoHasta}`
    );
    return response.data;
  }
}
